module.exports = __webpack_public_path__ + "img/protected.c9e7b8a8.png";